/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { isBoolean } from "utils/lodashUtils";
import { hudUiControlAlignments, animationType } from "constants/enums";
import { HUD_ANIMATION_OUT_DURATION, HUD_ANIMATION_IN_DURATION } from "constants/constants";

const getHUDApis = stores => {
  function show(visible) {
    if (isBoolean(visible)) {
      stores.hudStore.setHudDisable(!visible);
      stores.hudStore.setHudExplicitlyDisabled(!visible);
    }
  }

  function dock(shouldDock) {
    if (isBoolean(shouldDock)) {
      stores.hudStore.setIsDocked(shouldDock);
    }
  }

  function addUIControl(component, alignment = hudUiControlAlignments.RIGHT) {
    return stores.hudStore.addExternalComponent(component, alignment);
  }

  function removeUIControl(componentId) {
    stores.hudStore.removeComponent(componentId);
  }

  function fadeIn(duration = HUD_ANIMATION_IN_DURATION) {
    return stores.hudStore.show(animationType.FADE, duration);
  }

  function sliderIn(duration = HUD_ANIMATION_IN_DURATION) {
    return stores.hudStore.show(animationType.SLIDE, duration);
  }

  function sliderOut(duration = HUD_ANIMATION_OUT_DURATION) {
    return stores.hudStore.hide(animationType.SLIDE, duration);
  }

  function fadeOut(duration = HUD_ANIMATION_OUT_DURATION) {
    return stores.hudStore.hide(animationType.FADE, duration);
  }

  function showPageViewSwitcher(visible) {
    stores.hudStore.setPageViewSwitcherVisibility(visible);
  }

  return {
    show,
    dock,
    addUIControl,
    removeUIControl,
    fadeIn,
    fadeOut,
    sliderIn,
    sliderOut,
    showPageViewSwitcher
  };
};

export const registerHUDApis = stores => {
  apiFactory.registerApi(publicApiNames.HUD, clientName => getHUDApis(stores), true);
};
